module.exports = __webpack_public_path__ + "img/delete.4d694717.png";